<template>
  <BoxCard>
    <template #header>My personal learning goals</template>
    <template #content>
      <div class="text-vice-teal-700">
        {{ this.$page.props.session.reflection?.my_goals }}
      </div>
    </template>
  </BoxCard>
</template>

<script>
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'MyPersonalGoals',
  components: { BoxCard },
};
</script>

<style scoped></style>
